module.exports = __webpack_public_path__ + "media/images/eyecatch-correction-sm-d4b2fbbe5623d5aa8d88372d2e0cdc4f.svg";